import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core';
import { DataFieldEditBase } from '../data-field-edit-base';

@Component({
    selector: 'data-field-edit-name',
    template: `
        <fi-name-input [labelTextId]="'common.name' | fiAppText" [(ngModel)]="dataFieldObject.Name" />
    `,
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: { class: 'data-field-edit-name' },
    standalone: false,
})
export class DataFieldEditNameComponent extends DataFieldEditBase {}
